export default "dist/images/block-count-up-plain-2.0f3e152.png";